import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';
import { Link } from 'react-router-dom';
import '../styles/protected.css';

function ProtectedPage() {
    const navigate = useNavigate();
    const auth = useAuth();
    const { user } = useAuth();

    const handleLogout = () => {
        auth.logout(() => {
            navigate('/');
        });
    };

    const enterFullscreen = () => {
        const element = document.documentElement; // Cały dokument
        if (element.requestFullscreen) {
        element.requestFullscreen().catch((err) => {
            console.error("Nie udało się włączyć pełnoekranowego:", err);
        });
        } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen(); // Safari
        } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen(); // Edge/IE
        } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen(); // Firefox
        }
    };

    return (
        <div className='page'>
            <header>
                <h1>Witaj, {user.name}!</h1>
                <button onClick={enterFullscreen}>Pełny Ekran</button>
                <button onClick={handleLogout}>Wyloguj się</button>
            </header>
            <div className='buttons'>
                <Link to="/protected/client-screen">
                    Ekran klienta
                </Link>
                <Link to="/protected/my-results" state={user}>
                    Moje wyniki
                </Link>
            </div>
            <footer>
                <p>pomoc: <span>it@azarex.pl</span></p>
            </footer>
        </div>
    );
}

export default ProtectedPage;
